import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import * as i4 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails, getDataSourceCountryList, SetDataSourceCountryList } from 'visa-store';
import * as i1 from 'cache-country-list';
import * as i2 from 'reference-library';
import * as i3 from 'app-services-library';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';

class VdAddressService {
    constructor() { }
}
VdAddressService.ɵfac = function VdAddressService_Factory(t) { return new (t || VdAddressService)(); };
VdAddressService.ɵprov = i0.ɵɵdefineInjectable({ token: VdAddressService, factory: VdAddressService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddressService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function VdAddressComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r2.name);
} }
function VdAddressComponent_option_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r3.stateProvinceCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", item_r3.stateProvinceName, " ");
} }
class VdAddressComponent {
    constructor(apiService, referenceLibraryService, appServicesLibraryService, store) {
        this.apiService = apiService;
        this.referenceLibraryService = referenceLibraryService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.store = store;
        this.disabledControls = false;
        this.group = new FormGroup({});
        this.listStates = [];
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        this.getCountry();
        this.initForm();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    initForm() {
        let fmg = Object.assign(this.groupName);
        let country = this.inputParams.value && this.inputParams.value.country ? this.inputParams.value.country : '';
        let state = this.inputParams.value && this.inputParams.value.state ? this.inputParams.value.state : '';
        let addressLine1 = this.inputParams.value && this.inputParams.value.addressLine1 ? this.inputParams.value.addressLine1 : '';
        let address2 = this.inputParams.value && this.inputParams.value.addressLine2 ? this.inputParams.value.addressLine2 : '';
        let city = this.inputParams.value && this.inputParams.value.city ? this.inputParams.value.city : '';
        let locality = this.inputParams.value && this.inputParams.value.locality ? this.inputParams.value.locality : '';
        let postCode = this.inputParams.value && this.inputParams.value.pincode ? this.inputParams.value.pincode : '';
        let stateProvinceCode = this.inputParams.value && this.inputParams.value.stateProvinceCode ? this.inputParams.value.stateProvinceCode : '';
        if (country) {
            this.handleCountryChange(country, true);
        }
        this.group.addControl(fmg, new FormGroup({
            addressLine1: new FormControl(addressLine1),
            addressLine2: new FormControl(address2),
            country: new FormControl(country),
            state: new FormControl(state),
            stateProvinceCode: new FormControl(stateProvinceCode),
            city: new FormControl(city),
            locality: new FormControl(locality),
            pincode: new FormControl(postCode)
        }));
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleFields();
            });
        }
    }
    getCountry() {
        this.store.pipe(select(getDataSourceCountryList))
            .pipe(take(1))
            .subscribe((data) => {
            if (data && data.length > 0) {
                this.referenceLibraryService.translateArray(data, 'name')
                    .then(translated => {
                    this.countryList = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
            else {
                this.referenceLibraryService.getDataSource('COUNTRY', '')
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.referenceLibraryService.translateArray(response || [], 'name')
                        .then(translated => {
                        this.countryList = translated;
                    })
                        .catch(error => console.error("Translation error:", error));
                    this.store.dispatch(new SetDataSourceCountryList(response || null));
                });
            }
        });
    }
    handleCountryChange(evt, fromValue) {
        let countryCode = fromValue ? evt : evt.target.value;
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                this.referenceLibraryService.translateArray(states || [], 'stateProvinceName')
                    .then(translated => {
                    this.listStates = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    this.referenceLibraryService.translateArray(data || [], 'stateProvinceName')
                        .then(translated => {
                        this.listStates = translated;
                    })
                        .catch(error => console.error("Translation error:", error));
                });
            }
        });
    }
    toggleFields() {
        this.userType = sessionStorage.getItem('userTypeRole');
        if (((this.userType == 'Petitioner' || this.userType == 'Attorney') && this.inputData.stepStatusCode == 'COMPLETE') || (this.userType == 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode == 'SUBMIT'))) {
            // this.childGroup.disable();
            this.group.disable();
        }
        else {
            //  this.childGroup.enable();
            this.group.enable();
        }
    }
    OnStateSelect(evt) {
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
VdAddressComponent.ɵfac = function VdAddressComponent_Factory(t) { return new (t || VdAddressComponent)(i0.ɵɵdirectiveInject(i1.CacheCountryListService), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.AppServicesLibraryService), i0.ɵɵdirectiveInject(i4.Store)); };
VdAddressComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdAddressComponent, selectors: [["lib-vd-address-location"]], inputs: { address: "address", groupName: "groupName", inputParams: "inputParams", inputData: "inputData", group: "group" }, decls: 38, vars: 12, consts: [[1, "row", 3, "formGroup"], [1, "row", 3, "formGroupName"], [1, "col-6", "mb-2"], [1, "label-cls", "common-bene-class-for-translation"], ["type", "text", "formControlName", "addressLine1", "placeholder", "Address 1", 1, "im-input", "col-md", 3, "maxlength"], ["type", "text", "formControlName", "addressLine2", "placeholder", "Address 2", 1, "im-input", "col-md", 3, "maxlength"], [1, "row"], ["formControlName", "country", 1, "form-control", "fixed-width", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], [1, "col-6", "mb-2", 3, "hidden"], ["formControlName", "stateProvinceCode", 1, "form-control", "fixed-width", 3, "change"], ["type", "text", "formControlName", "state", "placeholder", "State", 1, "im-input", "col-md", 3, "maxlength"], [1, "col", "mb-2", "pt-3"], ["type", "text", "formControlName", "city", "placeholder", "City", 1, "im-input", "col-md", 3, "maxlength"], ["type", "text", "formControlName", "locality", "placeholder", "Locality", 1, "im-input", "col-md", 3, "maxlength"], ["type", "text", "formControlName", "pincode", "placeholder", "Zipcode", 1, "im-input", "col-md", 3, "maxlength"], [3, "value"]], template: function VdAddressComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, "Address Line 1");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "input", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 2);
        i0.ɵɵelementStart(7, "label", 3);
        i0.ɵɵtext(8, "Address Line 2");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "input", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "div", 2);
        i0.ɵɵelementStart(12, "label", 3);
        i0.ɵɵtext(13, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "select", 7);
        i0.ɵɵlistener("change", function VdAddressComponent_Template_select_change_14_listener($event) { return ctx.handleCountryChange($event); });
        i0.ɵɵtemplate(15, VdAddressComponent_option_15_Template, 2, 2, "option", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 9);
        i0.ɵɵelementStart(17, "label", 3);
        i0.ɵɵtext(18, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "select", 10);
        i0.ɵɵlistener("change", function VdAddressComponent_Template_select_change_19_listener($event) { return ctx.OnStateSelect($event); });
        i0.ɵɵtemplate(20, VdAddressComponent_option_20_Template, 2, 2, "option", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 9);
        i0.ɵɵelementStart(22, "label", 3);
        i0.ɵɵtext(23, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(24, "input", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 6);
        i0.ɵɵelementStart(26, "div", 12);
        i0.ɵɵelementStart(27, "label", 3);
        i0.ɵɵtext(28, "City");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(29, "input", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 12);
        i0.ɵɵelementStart(31, "label", 3);
        i0.ɵɵtext(32, "Locality");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(33, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 12);
        i0.ɵɵelementStart(35, "label", 3);
        i0.ɵɵtext(36, "ZIP / Postal Code");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(37, "input", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.groupName);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.countryList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", !((ctx.listStates == null ? null : ctx.listStates.length) > 0));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.listStates);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", !((ctx.listStates == null ? null : ctx.listStates.length) == 0));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxlength", ctx.inputParams == null ? null : ctx.inputParams.maxLength);
    } }, directives: [i5.NgControlStatusGroup, i5.FormGroupDirective, i5.FormGroupName, i5.DefaultValueAccessor, i5.NgControlStatus, i5.FormControlName, i5.MaxLengthValidator, i5.SelectControlValueAccessor, i6.NgForOf, i5.NgSelectOption, i5.ɵangular_packages_forms_forms_z], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddressComponent, [{
        type: Component,
        args: [{
                selector: 'lib-vd-address-location',
                templateUrl: 'vd-address.component.html',
                styles: []
            }]
    }], function () { return [{ type: i1.CacheCountryListService }, { type: i2.ReferenceLibraryService }, { type: i3.AppServicesLibraryService }, { type: i4.Store }]; }, { address: [{
            type: Input
        }], groupName: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class VdAddressModule {
}
VdAddressModule.ɵfac = function VdAddressModule_Factory(t) { return new (t || VdAddressModule)(); };
VdAddressModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdAddressModule });
VdAddressModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdAddressModule, { declarations: [VdAddressComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [VdAddressComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdAddressModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    VdAddressComponent
                ],
                imports: [
                    CommonModule,
                    ReactiveFormsModule
                ],
                exports: [
                    VdAddressComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-address
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdAddressComponent, VdAddressModule, VdAddressService };
//# sourceMappingURL=vd-address.js.map
